module.exports = __webpack_public_path__ + "img/39_54.f3f7a795.png";